'use strict';

module.exports = function (ngModule) {
    ngModule.directive('makeLineChart', require('./makelinechart'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/linechart/index.js
 **/